import AppLayout from "../layout/AppLayout"

export default function OppositionPage() {
  return (
    <AppLayout title="Opposition">
      <div className="min-h-[24rem]" />
    </AppLayout>
  )
}
